import { Checkbox } from '@chakra-ui/react';

export const CheckboxRadio = (props: any) => (
  <Checkbox
    {...props}
    // eslint-disable-next-line react/destructuring-assignment
    isChecked={props?.['data-checked'] === ''}
    pointerEvents="none"
  />
);
